// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.centered {
  display: flex;
  align-items: center;
  justify-content: center;
}
.disabled {
  pointer-events: none;
  cursor: default;
}
.footer {
  background-color: lightgrey;
  padding: 20px;
  z-index: 15;
}

.iconSvg {
  overflow: visible;
  border-radius: 0 !important;
}

.eb {
  font-family: "EB Garamond", serif;
}

.cinzel {
  font-family: "Cinzel", serif;
}

.txtCenter {
  text-align: center;
}

.hover:hover {
  cursor: pointer;
}

.hide {
  display: none !important;
}

.rounded {
  border-radius: 6px;
}

.fullPageWidth {
  /* to account for 20px padding */
  width: calc(100% + 40px);
  margin-left: -20px;
  /* --------------------------- */
}

.container {
  max-width: 1100px;
  margin: 0 auto;
}

.textInput {
  display: block;
  margin-top: 4px;
  margin-bottom: 16px;
  height: 2.25em;
  width: 100%;
  border: 1px solid var(--dark);
  filter: var(--shadow-muted);
  border-radius: 6px;
  padding: 8px;
  font-size: 1.05em;
  font-family: "Kumbh Sans", sans-serif;
}

.twoColResponsiveGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 32px;
  max-width: 1100px;
  margin: 0 auto;
  align-items: center;
}

.twoColResponsiveGrid img {
  width: 100%;
  display: block;
  object-fit: cover;
  height: 100%;
  max-height: 500px;
}

@media (max-width: 650px) {
  .twoColResponsiveGrid {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
  .twoColResponsiveGrid :nth-child(1) {
    grid-row: 2;
  }
}

@media (min-width: 950px) {
  .fullPageWidth {
    width: calc(100% + 128px);
    margin-left: -64px;
  }
}

.formbanner {
  position: fixed;
  top: 10px;
  left: 10px;
  right: 10px;
  background-color: green;
  color: white;
  font-size: 32px;
  text-align: center;
  border-radius: 10px;
  padding: 10px 0;
  z-index: 999;
}

.subtext {
  font-size: 0.8em;
  color: var(--dark);
  margin-top: 4px;
  margin-bottom: 16px;
}

.inputRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* flex-wrap: wrap; */
  gap: 16px;
}
.inputRow .textInput {
  /* width: 48% !important; */
}
`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.centered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.disabled {\n  pointer-events: none;\n  cursor: default;\n}\n.footer {\n  background-color: lightgrey;\n  padding: 20px;\n  z-index: 15;\n}\n\n.iconSvg {\n  overflow: visible;\n  border-radius: 0 !important;\n}\n\n.eb {\n  font-family: \"EB Garamond\", serif;\n}\n\n.cinzel {\n  font-family: \"Cinzel\", serif;\n}\n\n.txtCenter {\n  text-align: center;\n}\n\n.hover:hover {\n  cursor: pointer;\n}\n\n.hide {\n  display: none !important;\n}\n\n.rounded {\n  border-radius: 6px;\n}\n\n.fullPageWidth {\n  /* to account for 20px padding */\n  width: calc(100% + 40px);\n  margin-left: -20px;\n  /* --------------------------- */\n}\n\n.container {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.textInput {\n  display: block;\n  margin-top: 4px;\n  margin-bottom: 16px;\n  height: 2.25em;\n  width: 100%;\n  border: 1px solid var(--dark);\n  filter: var(--shadow-muted);\n  border-radius: 6px;\n  padding: 8px;\n  font-size: 1.05em;\n  font-family: \"Kumbh Sans\", sans-serif;\n}\n\n.twoColResponsiveGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 32px;\n  max-width: 1100px;\n  margin: 0 auto;\n  align-items: center;\n}\n\n.twoColResponsiveGrid img {\n  width: 100%;\n  display: block;\n  object-fit: cover;\n  height: 100%;\n  max-height: 500px;\n}\n\n@media (max-width: 650px) {\n  .twoColResponsiveGrid {\n    grid-template-columns: 1fr;\n    grid-gap: 0;\n  }\n  .twoColResponsiveGrid :nth-child(1) {\n    grid-row: 2;\n  }\n}\n\n@media (min-width: 950px) {\n  .fullPageWidth {\n    width: calc(100% + 128px);\n    margin-left: -64px;\n  }\n}\n\n.formbanner {\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  background-color: green;\n  color: white;\n  font-size: 32px;\n  text-align: center;\n  border-radius: 10px;\n  padding: 10px 0;\n  z-index: 999;\n}\n\n.subtext {\n  font-size: 0.8em;\n  color: var(--dark);\n  margin-top: 4px;\n  margin-bottom: 16px;\n}\n\n.inputRow {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  /* flex-wrap: wrap; */\n  gap: 16px;\n}\n.inputRow .textInput {\n  /* width: 48% !important; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
